<template>
    <div class="wrapper-popup" v-show="showInvoice">
        <div class="card-popup">
            <a class="button-close" @click="showInvoice = !showInvoice">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="15"
                    viewBox="0 0 384 512"
                >
                    <path
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                    />
                </svg>
            </a>
            <div class="card-body">
                <div class="card-image">
                    <img
                        :src="base_url + '/images/check.png'"
                        id="img-check"
                        alt=""
                    />
                </div>
                <h3>
                    Pembayaran Starter Kit <br />
                    Honda Bikers Day 2024 Berhasil
                </h3>
                <div class="card-data">
                    <div v-if="loader" class="loading loading-double"></div>
                    <div v-else class="inner-data">
                        <h5>Detail Transaksi</h5>
                        <div class="wrapper-items">
                            <div class="item-data">
                                <span>Transaksi ID</span>
                                <span>{{ invoice.transaction_id }}</span>
                            </div>
                            <div class="item-data">
                                <span>Tanggal</span>
                                <span>{{ invoice.paid_at }}</span>
                            </div>
                            <div class="item-data">
                                <span>Metode Pembayaran</span>
                                <span
                                    v-if="
                                        invoice.payment_type ==
                                            'virtual_account'
                                    "
                                    >Virtual Account</span
                                >
                                <span
                                    v-else-if="
                                        invoice.payment_type ==
                                            'qris'
                                    "
                                    >QRIS</span
                                >
                                <span
                                    v-else-if="
                                        invoice.payment_type ==
                                            'retail_outlet'
                                    "
                                    >Retail Outlet</span
                                >
                                <span
                                    v-else-if="
                                        invoice.payment_type ==
                                            'ewallet'
                                    "
                                    >E-Wallet</span
                                >
                                <span v-else>COD / Bayar di tempat</span>
                            </div>
                            <div class="item-data">
                                <span>Nominal</span>
                                <span>{{ invoice.amount_text }}</span>
                            </div>
                            <div class="item-data">
                                <span>Status</span>
                                <span class="success">Sukses</span>
                            </div>
                        </div>
                        <div class="grand-price">
                            <span>Total</span>
                            <span>{{ invoice.amount_text }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showInvoice: false,
            base_url: "",
            app_url: "",
            api_url: "",
            invoice: {},
            loader: false
        };
    },
    created() {
        this.base_url = base_url;
    },
    methods: {
        async openInvoice(event) {
            this.loader = true;
            await axios
                .get(`${api_url}/member/event/${event.id}/invoice`)
                .then(response => {
                    if (response.status === 200) {
                        this.invoice = response.data;
                        setTimeout(() => {
                            this.loader = false;
                        }, 3000);
                    }
                })
                .catch(err => {
                    console.log(err, "err");
                });
            this.showInvoice = !this.showInvoice;
        }
    }
};
</script>
<style lang="scss" scoped>
.wrapper-popup {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgba(21, 21, 21, 0.8);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;

    .card-popup {
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        padding: 20px;
        width: 90%;
        max-width: 558px;
        height: auto;
        max-height: 90vh;
        overflow-y: auto;

        .button-close {
            position: absolute;
            left: auto;
            right: 15px;
        }

        .card-body {
            text-align: center;
            color: rgba(40, 40, 40, 1);
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .card-image {
                max-width: 50px;

                img {
                    width: 100%;
                }
            }

            .card-data {
                border: 1px solid #dbdbdb;
                border-radius: 10px;
                margin-top: 15px;
                padding: 20px;
                width: 100%;

                h5 {
                    font-size: 15px;
                    font-weight: 700;
                    text-align: left;
                }

                .wrapper-items {
                    position: relative;
                    border-bottom: 1px solid #dbdbdb;
                    padding-bottom: 10px;
                    margin-bottom: 15px;

                    .item-data {
                        display: flex;
                        justify-content: space-between;
                        padding: 5px 0;

                        .success {
                            background: rgba(83, 223, 60, 0.1);
                            padding: 6px 15px;
                            border-radius: 50px;
                            color: #24c852;
                        }

                        span {
                            font-size: 14px;
                            font-weight: 400;

                            &:last-child {
                                font-weight: 600;
                            }
                        }
                    }
                }
            }

            .grand-price {
                display: flex;
                justify-content: space-between;
                padding: 5px 0;

                span {
                    font-size: 15px;
                    font-weight: 600;
                }
            }

            h3 {
                font-size: 20px;
                margin-top: 15px;
            }

            p {
                font-size: 15px;
                width: 100%;
                max-width: 100%;
                margin-bottom: 55px;
                line-height: 1.4;
                word-wrap: break-word;
            }

            .button {
                padding-top: 15px;

                .btn {
                    width: 100%;
                    max-width: 100%;
                    font-weight: 700;
                    font-size: 14px;
                    padding: 20px;
                    height: 42px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:hover {
                        background-color: #333 !important;
                        color: #fff;
                    }
                }
            }

            .red-button {
                background-color: #e61b33;
                color: #fff;
                padding: 10px 20px;
                border-radius: 10px;
                font-weight: 700;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
            }
        }
    }
}

@media (max-width: 768px) {
    .wrapper-popup {
        .card-popup {
            padding: 15px;
            max-width: 90%;

            .card-body {
                .card-data {
                    .wrapper-items {
                        .item-data {
                            flex-direction: column;
                            align-items: flex-start;
                            justify-content: flex-start;

                            span.success {
                                background: rgba(83, 223, 60, 0.1);
                                padding: 6px 15px;
                                border-radius: 50px;
                                color: #24c852;
                                text-align: center !important;
                            }

                            span {
                                width: 100%;
                                text-align: left;

                                &:last-child {
                                    text-align: left;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 576px) {
    .wrapper-popup {
        .card-popup {
            .card-body {
                padding: 0 !important;

                .card-image {
                    max-width: 40px;
                }

                h3 {
                    font-size: 16px;
                    margin-top: 15px;
                }

                .card-data {
                    h5 {
                        font-size: 15px;
                        font-weight: 700;
                        text-align: left;
                    }

                    .wrapper-items {
                        .item-data {
                            span {
                                font-size: 11px;
                            }
                        }
                    }
                }

                .grand-price {
                    span {
                        font-size: 12px;
                    }
                }
            }
        }
    }
}
</style>
